<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mi2xzw/tc-custom/9781035844654.jpg?1724126252726" alt="This image is the cover for the book My Safe Space"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Safe Space
      </h1>
      <p class="bookDescription body article font2">
        <p>Welcome to My Safe Space, a haven of peace and tranquility that resides within your heart. This imagined sanctuary is a place to plan, dream, and make those dreams come true. Where your desires are met with satisfaction. ‘An apple a day keeps the doctor away,’ so they say. But here, a poem a day empowers you to reach for the stars. Filled with vivid verse that speaks to your core, this collection makes you realize imagination transcends the mind: its manifestation lies within your grasp. The atmosphere brims with positivity. A walk on the clouds offers hope. A dance with angels may summon love. You can’t help but feel emboldened. Dazzled by kaleidoscopes of color, you become the hero of your story. In this boundless space, you are unlimited, free to be and go wherever you desire. No codes, no keys, no borders or barriers. It exists in your mind, but its magic may leave you forever changed. So, join the club, get inspired, and transform.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kikisun
      </h2>
      
      <p class="authorDescription body article">Kikisun was the first born to Mildred and John and the first grandchild to Fanny and Benson. She was pampered with love by the four of them. They taught her to pray, read and write long before she was five years old. After a sad incident at her grandparents’ homestead in Nerwande, her father cleared a space for her where she could read and write without being disturbed. It was difficult to keep creating such a place at their own house because the family kept moving. She herself attended a total of eight schools, from year 1 to year 11. Her father, therefore, advised and helped her to recreate that place at Nerwande, with its beautiful views in her mind. Now, that image is so imbedded in her and keeps popping up unexpectedly.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6cdd7800